import * as Yup from "yup";
import { SearchClientFormProps } from ".";
import { validaCpf } from "../../utils/validations";

export const getSearchClientFormSchema = (
  currentDoc: SearchClientFormProps["currentDoc"],
  currentDocOption: { label: string; placeholder: string }
) =>
  Yup.object({
    doc: Yup.string()
      .required(`${currentDocOption.label} é obrigatório`)
      .test(
        "test_cpf",
        `Informe um ${currentDocOption.label} válido`,
        (value) => {
          if (currentDoc === "client_id") return true;
          if (!value) return false;

          const onlyNumbers = value.split(".").join("").replace("-", "");
          return validaCpf(onlyNumbers);
        }
      ),
  });

type FnReturn = ReturnType<typeof getSearchClientFormSchema>;
export type SearchClientFormSchema = Yup.InferType<FnReturn>;
